import React, { useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";
import axios from 'axios';
import { useToast } from "../contexts/ToastContext";
import { useHistory } from "react-router-dom";
import CustomCaptcha from "./CustomCaptcha";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { confirmPopup } from "primereact/confirmpopup";

const SendPreventivo = ({ setVisible, preventivo, prevTab, extraTab }) => {

    const history = useHistory();
    const [disabilitaInvia, setDisabilitaInvia] = useState()
    const [infoUtente, setInfoUtente] = useState({nome: "", email: "", tel: ""})
    const [email2, setEmail2] = useState('')
    const [validation, setValidation] = useState([])
    //id casuale per evitare autocompeltamento nella mail di conferma
    const confmailID = 'input_' + Math.random().toString(36).substring(2, 9)
    const { showToast } = useToast();

    function validaEmail(email) {
        const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regexEmail.test(email);
    }

    const valida = () => {
        const _val = []
        if (!infoUtente.nome || infoUtente.nome.length < 5) {
            _val.push("name")
        }
        if (!infoUtente.email || !validaEmail(infoUtente.email)) {
            _val.push("mail")
        }
        if (!email2 || email2 !== infoUtente.email) {
            _val.push("mailconf")
        }
        if (!infoUtente.tel || infoUtente.tel.length < 5) {
            _val.push("tel")
        }

        setValidation(_val)
        return (_val.length === 0)
    }

  const submit = () => {
    axios.post('https://backend.mnediliziaristrutturazione.com/preventivo',
        { "preventivo": prevTab, "infoUtente": infoUtente, "preventivoJson": preventivo, "extraTab": extraTab },
        { 
            headers: { 'Content-Type': 'application/json' } 
        })
        .then(() => {
            setVisible(false)

            history.push("/")

            showToast({
                severity: "success",
                summary: "Inviato",
                detail: "Preventivo inviato con successo, riceverai una mail con il preventivo",
                life: 3000,
            });
        })
        .catch(error => {
            showToast({
                severity: "error",
                summary: "ERRORE",
                detail: "Errore nell'invio del preventivo",
                life: 3000,
            });
        })
}
  
    const accept = () => {
       
    };

    const reject = () => {
        
    };

    const showTemplate = (event) => {
      
        confirmDialog({
            
            group: 'templating',
            header: 'Confirmation',
            message: <CustomCaptcha/>,
            accept,
            reject
        });
    };

    const handleInvia2 = () => {

        if (valida()) {
            axios.post('https://backend.mnediliziaristrutturazione.com/preventivo',
                { "preventivo": prevTab, "infoUtente": infoUtente, "preventivoJson": preventivo, "extraTab": extraTab })
                .then(() => {
                    setVisible(false)

                    history.push("/")

                    showToast({
                        severity: "success",
                        summary: "Inviato",
                        detail: "Preventivo inviato con successo, riceverai una mail con il preventivo",
                        life: 3000,
                    });
                })
                .catch(error => {
                    showToast({
                        severity: "error",
                        summary: "ERRORE",
                        detail: "Errore nell'invio del preventivo",
                        life: 3000,
                    });
                })
        }
    }



    const dialogFooter = () => {
        return (
            <>
            <div>
                <Button label="Invia"   className="p-2" icon="pi pi-send" onClick={(e)=>handleInvia2(e)}   autoFocus />
                <Button label="Annulla" className="p-2" severity={"secondary"} icon="pi pi-times" onClick={() => setVisible(false)} />
            </div>
            </>
        )
    }

    return (
          <>
            <Dialog 
                    id={'clientInfoDialogID'} 
                    visible={true} 
                    modal={true}
                    header={'Invia preventivo'} 
                    style={{ width: '70vw' }}
                    footer={dialogFooter} 
                    onHide={() => setVisible(false)}
            >
                <ConfirmDialog group="templating" />
            <div>
                Salva il tuo preventivo ed invialo a M&N edilizia e ristrutturazioni. Le informazioni inserite non verranno inviate a terzi.
            </div>
            <div className='mt-4'>
                <div className="flex flex-column align-items-start mb-3 gap-2">
                    <label htmlFor="name" className="">Nome</label>
                    <InputText id="name" placeholder="Inserisci il tuo nome e cognome" className={`${validation.includes("name") ? 'p-invalid' : ''} mr-2`} keyfilter="alpha"
                        value={infoUtente.nome} onChange={(e) => setInfoUtente({ ...infoUtente, nome: e.target.value })} style={{ width: '100%' }} />
                    {validation.includes("name") && <Message severity="error" text="nominativo richiesto" />}
                </div>
                <div className="flex flex-column align-items-start mb-3 gap-2">
                    <label htmlFor="email" className="">E-mail</label>
                    <InputText id="email" placeholder="Inserisci la tua e-mail" className={`${validation.includes("mail") ? 'p-invalid' : ''} mr-2`} keyfilter="email"
                        value={infoUtente.email} onChange={(e) => setInfoUtente({ ...infoUtente, email: e.target.value })} style={{ width: '100%' }} />
                    {validation.includes("mail") && <Message severity="error" text="e-mail valida richiesta" />}
                </div>
                <div className="flex flex-column align-items-start mb-3 gap-2">
                    <label htmlFor={confmailID} className="">Conferma e-mail</label>
                    <InputText id={confmailID} placeholder="Reinserisci la tua e-mail" className={`${validation.includes("mailconf") ? 'p-invalid' : ''} mr-2`} keyfilter="email"
                        value={email2} onChange={(e) => setEmail2(e.target.value)} style={{ width: '100%' }} />
                    {validation.includes("mailconf") && <Message severity="error" text="e-mail non corrisponde" />}
                </div>
                <div className="flex flex-column align-items-start gap-2">
                    <label htmlFor="tel" className="">Telefono</label>
                    <InputText id="tel" placeholder="Inserisci un contatto telefonico" className={`${validation.includes("tel") ? 'p-invalid' : ''} mr-2`} keyfilter="pint"
                        value={infoUtente.tel} onChange={(e) => setInfoUtente({ ...infoUtente, tel: e.target.value })} style={{ width: '100%' }} />
                    {validation.includes("tel") && <Message severity="error" text="Telefono richiesto" />}
                </div>
            </div>
        </Dialog>
        </>
    )
}

export default SendPreventivo